import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { theme } from '../../styles';

export const StyledCardCarousel = styled.div`

.image {
  aspect-ratio: 16/9;
  max-width: 269px;
  max-height: 364px;
  width: 100%;
  object-fit: cover;
  @media ${theme.mediaQuery.allMobiles} {
    max-width: none;
  }
}
.addButton{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 18px;
  padding: 5px;
  max-height: 32px;
  max-width: 164px;
  margin: 0 auto !important;
  background-color: var(--t-brand-bg-color);
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
  font-size:12px;
  line-height:16px;
  font-weight:700 !important;
}
.carousel-text{
  .ebrowbg {
    background-color: var(--t-parent-brand-bg-color);
    margin-bottom: 5px;
    span {
      font-weight: 400 !important;
      color: var(--t-parent-brand-fg-color);
      padding: 0 5px;
    }
  }
  display:flex;
  flex-direction:column;
  gap:5px;
  align-items:flex-start;
  max-width:240px;
  padding: ${toRem(19)} ${toRem(45)} ${toRem(25)} ${toRem(18)} !important;
  @media ${theme.mediaQuery.allMobiles} {
    max-width: none;
  }
}
.header-text {
  font-size: ${toRem(14)};
  font-weight: 400;
  line-height: 20px;
  
}
.description{
  font-size: ${toRem(14)};
  font-weight: 400;
  line-height: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
   text-overflow: ellipsis;
   overflow: hidden;
   margin-bottom: 0;
   letter-spacing: 0;
  text-transform: none;
  color:var(--t-brand-fg-color);
  width: 100%;
}
.survey-wrapper__background{
  padding: 0;
  background: none;
}
.custom_click_track{
  font-size: ${toRem(13)};
  font-weight: 400;
  line-height: 17px;
}

    .carouselControlType3b{
    padding-top:24px;
      @media ${theme.mediaQuery.allMobiles} {
        padding-top:12px;
      }
        div{
         &:nth-child(2){
          padding-bottom:3px;
          overflow: visible !important;
         }
        }
    }
  .glide {
  padding-bottom:0px;
    &__track {
      padding-top: ${toRem(24)};
      @media ${theme.mediaQuery.allMobiles} {
      padding-top: ${toRem(16)};
      }
      .glide__slides_authoring {.carouselControlType3b .left-arrow
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
          .glide__slide{
            height: auto;
            box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
            border:1px solid #EEE;
            @media ${theme.mediaQuery.tabletScreenBetween} {
              max-width: 251px !important;
          }
          }
      }
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    .glide__arrows{
      .icon-arrow-right, .icon-arrow-left{
      &:before{
      font-size:24px;
      }
      }
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
      .carouselControlType1 {
        .right-arrow {
          right: -1rem;
         
        }
        .left-arrow {
          left: -1rem;
          
      }
    }
  }
  .glide--swipeable {
    cursor: default;
  }
  .m-button-secondary {
    @media ${theme.mediaQuery.allMobiles} {
      margin: 0 auto !important;
    }
  }
`;
